import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from '@igo2/core/language';
@Component({
    selector: 'app-pop-up-rde',
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    templateUrl: './pop-up-rde.component.html',
    styleUrl: './pop-up-rde.component.scss'
})
export class PopUpRdeComponent {
  languageService = inject(LanguageService);

  constructor(public dialogRef: MatDialogRef<PopUpRdeComponent>) { }

  information = this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.information');
  questionConserverResultatPrecedent = this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.questionConserverResultatPrecedent');
  oui = this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.oui');
  non = this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.non');
}
